export const GIVEAWAY_ADMIN_PREFIX = 'GIVEAWAY_';
export const GIVEAWAY_RESET = `${GIVEAWAY_ADMIN_PREFIX}_GIVEAWAY_RESET`;
export const resetGiveaway = () => ({
  type: GIVEAWAY_RESET
});